import React, { useState } from 'react';
import { veagroupLogo, subsidiaries } from '../../../data/home/home';

const arrowSvg = (
  <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M12 5l7 7-7 7" /></svg>
);

const SubCompaniesSection: React.FC = () => {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <section className="py-0 bg-white dark:bg-black transition-colors duration-500">
      <div className="w-full flex items-center justify-center py-8 transition-colors duration-500">
        <div className="flex-1 h-px bg-gray-300 dark:bg-gray-600 mx-8" />
        <span className="text-5xl font-bold dark:text-white whitespace-nowrap">
        <img src={veagroupLogo} alt="VEA Group Logo" className="h-10 w-auto" />
        </span>
        <div className="flex-1 h-px bg-gray-300 dark:bg-gray-600 mx-8" />
      </div>
      <div className="w-full max-w-full mx-auto relative">
        {/* Shared big background image */}
        <div className="absolute inset-0 w-full h-full z-0 transition-colors duration-500">
          <img
            src="/images/home/logo_subcompany.png"
            alt="VEA Group"
            className="w-full h-full object-cover object-center"
            draggable={false}
          />
        </div>
        {/* Content grid overlays the background */}
        <div className="relative z-10 w-full h-[160px] md:h-[260px] lg:h-[450px] grid grid-cols-5 gap-0">
          {subsidiaries.map((sub, idx) => (
            <a
              key={sub.name}
              href={sub.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`flex flex-col items-start justify-end h-full w-full px-3 md:px-6 pb-4 md:pb-8 cursor-pointer transition-all duration-300 group relative overflow-hidden border-r border-white/30 dark:border-white/20 ${idx === subsidiaries.length - 1 ? 'border-r-0' : ''}`}
              onMouseEnter={() => setHovered(idx)}
              onMouseLeave={() => setHovered(null)}
              style={{ minHeight: 110 }}
            >
              {/* Mirror overlay, disappears on hover */}
              <div className={`absolute inset-0 z-10 transition-all duration-500 bg-black/60 dark:bg-black/80 ${hovered === idx ? 'bg-black/0 dark:bg-black/0' : ''}`} />
              {/* Company logo appears only on hover, with bottom-to-top effect and filled */}
              {hovered === idx && (
                <img
                  src={sub.image}
                  alt={sub.name}
                  className="absolute inset-0 w-full h-full object-contain object-center z-20 transition-all duration-500 animate-fade-up"
                  style={{ background: 'rgba(255,255,255,0.85)' }}
                  draggable={false}
                />
              )}
              <span className="text-orange-500 font-bold text-xs md:text-base mb-1 z-30 relative transition-colors duration-500">{`0${idx + 1}`}</span>
              <h3 className="text-white text-sm md:text-lg lg:text-xl font-bold mb-2 leading-tight drop-shadow-lg z-30 relative transition-colors duration-500">
                {sub.name}
              </h3>
              {hovered === idx && (
                <p className="text-white text-xs md:text-sm lg:text-base mb-2 md:mb-3 max-w-xs drop-shadow-lg transition-all duration-500 animate-fade-in z-30 relative">
                  {sub.info}
                </p>
              )}
              <span
                className="mt-2 px-3 md:px-5 py-1.5 md:py-2 border border-white text-white rounded bg-transparent font-medium hover:bg-white hover:text-black transition-colors duration-300 text-xs md:text-base inline-flex items-center gap-2 z-30 relative"
                tabIndex={-1}
              >
                Visit {sub.name} {arrowSvg}
              </span>
            </a>
          ))}
        </div>
        <style>{`
          @media (max-width: 768px) {
            .grid-cols-1.md:grid-cols-4 { grid-template-columns: 1fr 1fr; }
          }
          @keyframes fade-in {
            from { opacity: 0; transform: translateY(16px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-in { animation: fade-in 0.5s ease; }
          @keyframes fade-up {
            from { opacity: 0; transform: translateY(60px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-up { animation: fade-up 0.5s cubic-bezier(0.4,0,0.2,1); }
        `}</style>
      </div>
    </section>
  );
};

export default SubCompaniesSection; 